import { DATADOG } from 'core/constants/thirdParties'

export function getServiceName(productName: string) {
  return `${productName}${DATADOG.SERVICE_NAME_SUFFIX}`
}
